import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ClientActions = ({ accountId, onDelete, permissions, index }) => {
  const { t } = useTranslation();

  return (
    <td className="d-flex justify-content-center">
      {(permissions.canEditAnyClient || permissions.canEditMyClient) && (
        <Link
          to={`/settings/any/clients/edit/${accountId}`}
          className="btn btn-sm btn-clean btn-icon btn-icon-md"
          title={t("Modifier")}
        >
          <i className="la la-edit" />
        </Link>
      )}

      {(permissions.canDeleteAnyClient || permissions.canDeleteMyClient) && (
        <button
          onClick={() => onDelete(accountId, index)}
          className="btn btn-sm btn-clean btn-icon btn-icon-md"
          title={t("Supprimer")}
        >
          <i className="la la-trash" />
        </button>
      )}
    </td>
  );
};

export default ClientActions;
